import React, { useState } from "react";
import { dawQuestions } from "../../data/staticData";

export default function DAWPage() {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const totalPages = Math.ceil(dawQuestions.length / itemsPerPage);
  const paginatedData = dawQuestions.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <section className="relative w-full bg-gray-50 min-h-screen px-4 py-12 md:px-6">
      <div className="max-w-6xl mx-auto mb-12 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold text-blue-900 drop-shadow-sm">
          Daily Answer Writing (DAW)
        </h2>
        <p className="text-gray-700 mt-3 text-base md:text-lg max-w-2xl mx-auto">
          Practice questions for your UPSC preparation.
        </p>
      </div>

      {dawQuestions.length === 0 ? (
        <p className="text-center text-gray-600">No DAW entries found.</p>
      ) : (
        <div className="space-y-6 max-w-4xl mx-auto">
          {paginatedData.map((entry) => (
            <div
              key={entry._id}
              className="bg-white p-6 rounded-lg shadow-md border border-gray-200"
            >
              <h3 className="font-bold text-lg mb-2">{entry.examTitle}</h3>
              <p className="text-gray-700 mb-4">
                Subject: <span className="font-semibold">{entry.subject}</span>
              </p>

              {entry.questions.map((q, idx) => (
                <div key={idx} className="mb-4 border-b border-gray-100 pb-4">
                  <p className="text-gray-700 font-medium">
                    {idx + 1}. {q}
                  </p>
                </div>
              ))}
            </div>
          ))}

          {totalPages > 1 && (
            <div className="flex justify-center space-x-2 mt-6 flex-wrap">
              <button
                onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                disabled={currentPage === 1}
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
              >
                Prev
              </button>
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentPage(i + 1)}
                  className={`px-3 py-1 rounded ${
                    currentPage === i + 1
                      ? "bg-blue-600 text-white"
                      : "bg-gray-200 hover:bg-gray-300"
                  }`}
                >
                  {i + 1}
                </button>
              ))}
              <button
                onClick={() =>
                  setCurrentPage((p) => Math.min(p + 1, totalPages))
                }
                disabled={currentPage === totalPages}
                className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50"
              >
                Next
              </button>
            </div>
          )}
        </div>
      )}
    </section>
  );
}
